import React, { Component } from "react";
import classNames from "classnames";

// LIBS
import API from "../../../api";
import { sumFormat } from "../../../lib/helpers/strings";

// UI
import { P, Header, Row, Col, Card } from "../../../ui";

class BiletsCountTypes extends Component {
  state = {
    countToday: {
      // Заканчиваются сегодня
      sum_give: 0,
      count: 0
    },
    countPrivilege: {
      // На льготном сроке
      sum_give: 0,
      count: 0
    },
    countOverdue: {
      // Просроченные
      sum_give: 0,
      count: 0
    }
  };

  async componentDidMount() {
    const {
      today,
      privilege,
      overdue
    } = await API.widgets.getBiletsCountByTypes();

    this.setState({
      countToday: today,
      countPrivilege: privilege,
      countOverdue: overdue
    });
  }

  itemBox = (
    title = "",
    countAndSumGive = {},
    colorCount = "",
    suffixInUrl = ""
  ) => {
    const classNameCount = classNames({
      [`color-${colorCount}`]: colorCount && colorCount.length
    });
    return (
      <Col lg={12} md={12} sm={12} xs={12} padding="no-top-bottom">
        <Card
          shadow={1}
          to={`/bilets${suffixInUrl && suffixInUrl.length ? suffixInUrl : ""}`}
        >
          <Row align="center">
            <Col padding="no" lg={6} md={6} sm={6} xs={6}>
              <P slim={true}>На сегодня</P>
              <Header size={6} margin="no" className={classNameCount}>
                {title}
              </Header>
            </Col>
            <Col padding="no" text="right" lg={6} md={6} sm={6} xs={6}>
              <Header
                big={true}
                size={6}
                margin="no"
                className={classNameCount}
              >
                {sumFormat(countAndSumGive.count || 0)}
              </Header>
            </Col>
          </Row>

          {/*
          <HR theme="dashed" mutted={true} margin="no" />

          <Row align="center">
            <Col padding="no" lg={6} md={6} sm={6} xs={12}>
              <P slim={true} mutted={true}>
                Сумма оценки вещей
              </P>
            </Col>
            <Col padding="no" text="right" lg={6} md={6} sm={6} xs={12}>
              <P slim={true} strong={true}>
                {sumFormat(countAndSumGive.sum_items || 0)}
              </P>
            </Col>
          </Row>
          */}
          <Row align="center">
            <Col padding="no" lg={6} md={6} sm={6} xs={12}>
              <P slim={true}>Сумма выдач</P>
            </Col>
            <Col padding="no" text="right" lg={6} md={6} sm={6} xs={12}>
              <P slim={true} strong={true}>
                {/* {sumFormat(countAndSumGive.sum_give || 0, "", minusSum)} */}
                {sumFormat(countAndSumGive.sum_give || 0)}
              </P>
            </Col>
          </Row>

          {/*
          <Row align="center">
            <Col padding="no" lg={6} md={6} sm={6} xs={12}>
              <P slim={true} mutted={true}>
                Разница
              </P>
            </Col>
            <Col padding="no" text="right" lg={6} md={6} sm={6} xs={12}>
              <P slim={true} strong={true} className="color-success">
                {sumFormat(
                  (countAndSumGive.sum_items || 0) -
                    (countAndSumGive.sum_give || 0),
                  "",
                  plusSum
                )}
              </P>
            </Col>
          </Row>
          */}
        </Card>
      </Col>
    );
  };

  render() {
    return (
      <Row>
        <Col lg={12} md={12} sm={12} xs={12} padding="no-top-bottom">
          <Header size={4}>Залоговые билеты</Header>
        </Col>
        <Col lg={12} md={12} sm={12} xs={12} padding="no">
          <Row>
            {this.itemBox(
              "Просроченных",
              this.state.countOverdue,
              "error",
              "?view=overdue"
            )}
            {this.itemBox(
              "Льготных",
              this.state.countPrivilege,
              "warning",
              "?view=privilege"
            )}
            {this.itemBox(
              "Заканчивающихся",
              this.state.countToday,
              null,
              "?view=today"
            )}
          </Row>
        </Col>
      </Row>
    );
  }
}

export default BiletsCountTypes;
